import React from 'react';
import Shift from './Shift';
import ShiftPress from './ShiftPress';
import styles from './ShiftWrapper.module.css';

function ShiftWrapper({ machine, hours, shifts, colorConfig }) {
  const isPress = machine?.type === 'press';

  return (
    <div className={styles.shiftWrapper}>
      {shifts.map((shift, index) => (
        <div key={index} className={styles.shiftItem}>
          {shift.label && <h3 className={styles.shiftLabel}>{shift.label}</h3>}

          {isPress ? (
            <ShiftPress
              hours={hours}               // dane godzinowe dla cotton (z CSV cotton_data.csv)
              startTime={shift.start}     // "HH:MM:SS"
              endTime={shift.end}         // "HH:MM:SS"
              shiftTarget={shift.target}  // cel dla zmiany (liczbowy) – dodaj w definicji shifts
            />
          ) : (
            <Shift
              hours={hours}               // dane godzinowe dla Zund
              startTime={shift.start}
              endTime={shift.end}
              colorConfig={colorConfig}
            />
          )}

        </div>
      ))}
    </div>
  );
}

export default ShiftWrapper;
